import React, {useState} from 'react'
import Layout from '../Layout/Layout';
import TopMenu from "~/Admin/Layout/TopMenu/TopMenu";
import {NavLink, Route} from "react-router-dom";
import AdminReportEvents from './AdminReportEvents/AdminReportEvents';
import AdminReportSummary from './AdminReportSummary/AdminReportSummary';
import AdminReportReg from './AdminReportReg/AdminReportReg';
import AdminReportTickets from './AdminReportTickets/AdminReportTickets';
import {connect} from "react-redux";
import "./reports.scss";

const AdminReports = ({match}) => {

    return (
        <Layout>

            <h1>Reports</h1>

            <TopMenu>
                <NavLink
                    activeClassName="active"
                    exact
                    to={`${match.path}`}>
                    Events
                </NavLink>
                <NavLink
                    activeClassName="active"
                    exact
                    to={`${match.path}/summary`}>
                    Summary
                </NavLink>
                <NavLink
                    activeClassName="active"
                    to={`${match.path}/registrations`}>
                    Registrations
                </NavLink>
                <NavLink
                    activeClassName="active"
                    to={`${match.path}/tickets`}>
                    Ticket
                </NavLink>
            </TopMenu>

            <div className="content reports-content mt-3">
                <Route exact path={`${match.path}`} component={AdminReportEvents} />
                <Route exact path={`${match.path}/summary`} component={AdminReportSummary} />
                <Route path={`${match.path}/registrations`} component={AdminReportReg} />
                <Route exact path={`${match.path}/tickets`} component={AdminReportTickets} />
            </div>

        </Layout>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminReports);
